import { DenseText } from '../typography';
import React from 'react';
import { TableColumnTextProps } from './table-column-text-props';
import styled from 'styled-components';

const TableColumnTextComponent = React.forwardRef<any, TableColumnTextProps>(
  (props, ref): React.ReactElement => {
    const { color, variant, ...rest } = props;
    return <DenseText {...rest} ref={ref} />;
  },
);

TableColumnTextComponent.displayName = 'TableColumnText';

export const TableColumnText = styled(TableColumnTextComponent)`
  display: flex;
  transition: color 120ms;
`;
